import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { HALF_SIZE } from '../../../../constants';
import styleClasses from '../../../../containers/try2/try2.module.scss';
import { selectedBtnStyle } from '../cardStyle';

interface ISectionDetail {
  currentItemName: string;
  defaultItemName: string;
  image: string;
  id: string;
  changeItemSize: string;
  title?: string;
  isHalf?: number;
  selectedtitle?: string;
  weight?: string;
  buttonClick:() => void
}
const SectionDetail: React.FC<ISectionDetail> = (props) => {
  const { currentItemName, defaultItemName, image, id, changeItemSize, title, isHalf, selectedtitle, weight,buttonClick } =
    props;
  const selected = currentItemName !== defaultItemName
  return (
    <label
      htmlFor={id}
      className={`${styleClasses.optional_selector
        } f-s18 font-Vcf w-100 shadow-box optional-selector pb-md-0 ${currentItemName !== defaultItemName &&
        `justify-content-between ${styleClasses.optional_selector_selected} ${styleClasses.kids_combo_item_img}`
        }`}
    >
      <div
        className={
          image
            ? `img_box px-2 ${styleClasses.kids_img_item}`
            : `${styleClasses.rounded_box} rounded-box clr-sec-white mx-auto`
        }
      >
        {image ? (
          <img src={image} className="img-fluid mb-1 mb-md-2" alt={currentItemName} />
        ) : (
          <span className="font-Vcf">{id}</span>
        )}
      </div>
      {currentItemName !== defaultItemName ? (
        <div className={`${styleClasses.try2_selected_item_content} f-s0`}>
          <p
            className={`${changeItemSize} p-16 clr-lt-black ls-normal mb-3 mb-md-4 px-2 px-md-0 f-sm-s11`}
            data-testid="kidsComboName"          >
            {isHalf ? HALF_SIZE.title_case + ' ' + currentItemName : currentItemName}

            <span className='d-block'>{parseInt(weight) > 0 && `${weight} cal`}</span>
            <button className={` item-select-btn btn d-inline-block py-1 py-md-3 px-3  f-s16 f-sm-s10 mt-3 d-md-none lh-lg`}
            style={{
              ...(selected && {
                ...selectedBtnStyle,
              }),
            }}
            onClick={selected && buttonClick}
            >
              { selected ? 'Selected' : 'Select'}
            </button>
            {selected && (
            <span className={`font-Visby-cf fw-bold desktop-selected-text py-1 py-md-3 px-3 bg-clr-dark-blue f-s16 f-sm-s10 clr-sec-white text-uppercase 
                          d-none d-md-block`}>
              {'Selected'}
            </span>
          )}
          </p>
        </div>) : (
       <div className="px-2">
          <h6
            className={`${changeItemSize} h4 font-Cls clr-lt-black ls-normal d-none mb-40 d-md-block`}
          >
            {currentItemName}
          </h6>
          <p className={`${styleClasses.inn_title_wrap} d-md-none f-s11`}>
            <strong className="f-s14">{title}</strong>
            <br />
            <button className={`item-select-btn btn d-inline-block py-1 py-md-3 px-3 f-s16 f-sm-s10 mt-3 d-md-none lh-lg`}>
              {'Select'}
            </button>
          </p>
        </div>
        )}
    </label>
  );
};

export default SectionDetail;
